export default "dist/a0b7f3f18d93f6730bb20aa64fb27644.png";